import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheEssenceOfBreath from "./sections/TheEssenceOfBreath";
import ThePaawanManifesto from "./sections/ThePaawanManifesto";
import SensoryImmersion from "./sections/SensoryImmersion";
import TheScienceOfPositivePressure from "./sections/TheScienceOfPositivePressure";
import SanctuaryEnvironments from "./sections/SanctuaryEnvironments";
import TheDelhiNcrLaunch from "./sections/TheDelhiNcrLaunch";
import PriorityAccessWaitlist from "./sections/PriorityAccessWaitlist";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheEssenceOfBreath />
      <ThePaawanManifesto />
      <SensoryImmersion />
      <TheScienceOfPositivePressure />
      <SanctuaryEnvironments />
      <TheDelhiNcrLaunch />
      <PriorityAccessWaitlist />
      <Footer />
    </div>;
}